export const environment = {
  production: false,
  apiUrl: 'https://apibeta.app.feedom.io/',
  auth0Domain: 'dev--wgp737q.us.auth0.com',
  auth0ClientId: 'aKtPT9r0KCukiuZaMPfRBUKkcQNSUmBy',
  auth0Audience: 'https://feedom-beta.com/api/v2/',
  auth0RedirectUrl: 'https://banner-audit-beta.app.feedom.io/login',
  allowedEmailDomains: ['adtomic.ai', 'adtomiclabs.com'],
};
